export const SET_PASSWORD_TEXT = {
  'set_password.header': {
    'en-GB': 'Reset your password',
    'nl-NL': 'Wachtwoord opnieuw instellen',
  },
  'set_password.password_label': {
    'en-GB': 'New Password',
    'nl-NL': 'Nieuw wachtwoord',
  },
  'set_password.password_placeholder': {
    'en-GB': 'Password',
    'nl-NL': 'Wachtwoord',
  },
  'set_password.password_rule': {
    'en-GB': 'Password must contain...',
    'nl-NL': 'Wachtwoord moet bevatten...',
  },
  'set_password.save_button': {
    'en-GB': 'Save',
    'nl-NL': 'Opslaan',
  },
  'set_password.skip_reset_button': {
    'en-GB': 'Skip Reset',
    'nl-NL': 'Overslaan',
  },
  'set_password.invalid_password_error': {
    'en-GB':
      'Enter 8 characters or more including one upper case, one lower case and a number',
    'nl-NL':
      'Geef 8 tekens of meer in, waaronder een hoofdletter, kleine letter en een cijfer',
  },
  'set_password.error_message': {
    'en-GB': 'Oops something went wrong, please try again',
    'nl-NL': 'Oeps, er ging iets mis, probeer het opnieuw',
  },
}
